// All URLs come from the .env file (see .env.example).
// Restart the dev server / rebuild after changing .env.
// There are no fallbacks: a variable missing from .env will be undefined here.

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const REFERRAL_BASE_URL = typeof window !== "undefined" && window.location?.origin
    ? `${window.location.origin}/register?ref=`
    : process.env.REACT_APP_REFERRAL_BASE_URL;

export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;

export const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL;
export const POSITION_SOCKET_URL = process.env.REACT_APP_OPEN_POSITION_SOCKET;

// Live Trades page socket (/CRM_OPEN_ORDER_LIST). When it is not set in .env the page uses the API only.
export const LIVE_TRADES_SOCKET_URL = process.env.REACT_APP_LIVE_TRADES_SOCKET;
